// Alpine `activityTimeline`: the type filter of activities/_timeline plus its
// lazily loaded "Mentioned me" list (a turbo-frame filled by
// timeline_mentions#show on first use).
//
// The frame swaps its content in silently, so a polite status region next to
// it reads out what arrived (the frame's [data-mentioned-me-summary]) or that
// loading failed. A failed load (network error, or a response without the
// frame, which Turbo would show as an unlocalized "Content missing") shows the
// localized error from the <template x-ref="mentionedMeError"> instead, and
// the next click on the filter tries again.

// Text for the status region once the frame has loaded.
export function loadedSummary(frame) {
  const el = frame?.querySelector?.("[data-mentioned-me-summary]");
  return el ? String(el.dataset.mentionedMeSummary || "").trim() : "";
}

// Text of the error template, read out in the status region.
export function templateText(template) {
  return String(template?.content?.textContent || "")
    .replace(/\s+/g, " ")
    .trim();
}

export function activityTimelineData() {
  return {
    filter: "all",
    mentionedMeStatus: "",
    mentionedMeFailed: false,

    showMentionedMe() {
      this.filter = "mentioned_me";
      const frame = this.$refs.mentionedMeFrame;
      if (!frame) return;

      if (this.mentionedMeFailed) {
        this.mentionedMeFailed = false;
        this.mentionedMeStatus = "";
        if (typeof frame.reload === "function" && frame.getAttribute("src")) {
          frame.reload();
          return;
        }
      }
      if (!frame.getAttribute("src")) frame.src = frame.dataset.src;
    },

    onMentionedMeLoad(event) {
      if (event?.target !== this.$refs.mentionedMeFrame) return;
      this.mentionedMeFailed = false;
      this.mentionedMeStatus = loadedSummary(this.$refs.mentionedMeFrame);
    },

    onMentionedMeError(event) {
      if (event?.target !== this.$refs.mentionedMeFrame) return;
      // turbo:frame-missing: keep Turbo from rendering "Content missing".
      // A network error (turbo:fetch-request-error) is left to Turbo, which
      // still has to settle the frame's request.
      if (event.type === "turbo:frame-missing") event.preventDefault?.();
      const template = this.$refs.mentionedMeError;
      if (template?.content) this.$refs.mentionedMeFrame.replaceChildren(template.content.cloneNode(true));
      this.mentionedMeFailed = true;
      this.mentionedMeStatus = templateText(template);
    }
  };
}

export default function registerTimelineMentionedMe(Alpine) {
  Alpine.data("activityTimeline", activityTimelineData);
}
